var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-button',{staticClass:"map-toggler",attrs:{"type":"secondary","icon":_vm.mapVisible ? 'hide-map' : 'ksodd-map',"active":_vm.mapVisible},on:{"click":function($event){return _vm.$emit('toggle')}}},[_vm._v(" "+_vm._s(_vm.$t(`map-toggler:${_vm.mapVisible ? 'hide' : 'show'}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }